import { render, staticRenderFns } from "./MoreFilters.vue?vue&type=template&id=9205674c&scoped=true"
import script from "./MoreFilters.vue?vue&type=script&lang=js"
export * from "./MoreFilters.vue?vue&type=script&lang=js"
import style0 from "./MoreFilters.vue?vue&type=style&index=0&id=9205674c&prod&lang=scss"
import style1 from "./MoreFilters.vue?vue&type=style&index=1&id=9205674c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9205674c",
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QField,QIcon});
